import { QuestionType, QuestionTypes } from '../../../../types/GlobalTypes';

export const checkIfWrongAnswersRequired = (questionType: QuestionType) => {
  return questionType === QuestionTypes.CLOSED;
};
